import { FunctionComponent } from "react";

import Title from "./Title";
import UserProfile from "./UserProfile";

const Header: FunctionComponent = () => {
  return (
    <div className="small-screen:grid grid-cols-3">
      <div className="flex h-8">
        <Title />
      </div>
      <div className="ml-auto flex">
        <UserProfile />
      </div>
    </div>
  );
};

export default Header;
